export const hasBuyNowItems = (items: any) => {
  return items.some((item: any) => item.buyNow)
}

export const getFilteredItems = (items: any) => {
  const filteredItems = items.filter((item: any) => item.buyNow)
  return filteredItems.length > 0 ? filteredItems : items
}
